import moment from "moment-timezone";
import useSWR from "swr";
import { useHasCompany } from "../../../utils/hooks/company";

/**
 * Fetches the overrides for a user within a given date range
 * @param {string} userId - The ID of the user to fetch overrides for
 * @param {string} from - The start date of the date range
 * @param {string} to - The end date of the date range
 */
export const useOverrides = (userId, from, to) => {
    const hasCompany = useHasCompany();

    return useSWR(() => {
        if (!hasCompany || !userId || !from || !to) {
            return null;
        }
        return {
            url: `/time-sheet/${userId}/overrides`,
            params: {
                startDate: moment(from).format("YYYY-MM-DD"),
                endDate: moment(to).format("YYYY-MM-DD"),
            }
        }
    });
}
